import { render, staticRenderFns } from "./FavoriteShopListItem.vue?vue&type=template&id=316d8d06&"
import script from "./FavoriteShopListItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteShopListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports